
import React, { useEffect, useState } from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  UncontrolledTooltip,
} from "reactstrap";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Select from "react-select"
import SelectCreatnale from "react-select/creatable"
import Dropzone from "react-dropzone";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCitiesByCountry, getCountries } from "../../../store/address/actions";
import { addNewVendor, updateVendor } from "../../../store/vendor/actions"
import { getVendor_cats } from "../../../store/vendor_cat/actions"
import imageBaseUrl from "../../../helpers/imageBaseUrl";
import { addNewClient, updateClient } from "../../../store/clients/actions";


const AddClient = (props) => {
  const location = useLocation()
  const history = useHistory()
const [removeImage,setRemoveImage] = useState(false)
  const [selectedFiles_2, setselectedFiles_2] = useState(
    location?.state?.image != null
      ? [{ preview: imageBaseUrl + location?.state?.image }]
      : []
  )
  const dispatch = useDispatch()
  useEffect(() => {
  dispatch(getVendor_cats({is_active:1}))
    dispatch(getCountries())
}, [dispatch])
  
function handleAcceptedFiles_2(files) {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  )
  setselectedFiles_2(files)
  setRemoveImage(false)
}

/**
 * Formats the size
 */
  
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}
  // Form validation 
  // const {
  //   name,email,phone,discount,country_id,city_id,city_name,building,
  //     floor,
  //     street,
  //     twitter_link,
  //     insta_link,
  //     facebook_link,
  //     log,
  //     banner_img,
  // } = location?.state
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: location?.state?.first_name || "",
      last_name: location?.state?.last_name || "",
      email: location?.state?.email || "",
      phone: location?.state?.phone || "",
      country_id: location?.state?.country_id || "",
      city_id: location?.state?.city_id || "",
      city_name: location?.state?.city_name || "",
      street: location?.state?.street || "",
      image: location?.state?.logo || "",
      password: "",
    },

    validationSchema: Yup.object({
      // email: Yup.string().required("Please Enter Your Email"),
      // phone: Yup.string().required("Please Enter Your Phone"),
    }),
    onSubmit: values => {

      try{
             let data = {
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        phone: values.phone,
        image: selectedFiles_2[0],
        removeImage:removeImage ? 1 : 0,
        password:values.password
      }

      if (location.state) {

        data.id = location.state.id
        dispatch(updateClient(data, history))
      } else {
         dispatch(addNewClient(data, history))
      }
      }catch(e){
        console.log(e)
      }
 
    },
  })

  const [selectedCountry, setselectedCountry] = useState({label:location?.state?.country_name,value:location?.state?.country_id})
  const [selectedCity, setselectedCity] = useState({
    label: location?.state?.city_name,
    value: location?.state?.city_id,
  })
  const countries = useSelector(state=>state.address.countries)
  const cities = useSelector(state => state.address.cities)
  const countriesOptions = countries?.map(country => {return { label: country.name, value: country.id } })
  const citiesOptions = cities?.map(city => {
    return { label: city.name, value: city.id }
  })
  useEffect(() => {
  _getCitiesByCountry(selectedCountry.value)
  }, [selectedCountry])
  
  function handleSelectCountry(selectedCountry) {
      _getCitiesByCountry(selectedCountry.value)
      setselectedCountry(selectedCountry)
    }
      function handleSelectCity(selectedCity) {
        setselectedCity(selectedCity)
      }
  function _getCitiesByCountry(id) {
    dispatch(getCitiesByCountry(id))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="vendors / add vendors" breadcrumbItem="" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Add new customer</h4>
                  <p className="card-title-desc">
                    {/* Parsley is a availity reactstrap validation. It helps you
                    provide your users with feedback on their form submission
                    before sending it to your server. */}
                  </p>

                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    className="custom-validation"
                  >
                    <div className="row">
                      <div className="mb-3 col-6">
                        <Label className="form-label">
                          First Name
                          <Label className="text-danger ms-1">*</Label>
                        </Label>
                        <Input
                          name="first_name"
                          placeholder="First Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.first_name || ""}
                          invalid={
                            validation.touched.first_name &&
                            validation.errors.first_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.first_name &&
                        validation.errors.first_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.first_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-6">
                        <Label className="form-label">
                          Last Name<Label className="text-danger ms-1">*</Label>
                        </Label>
                        <Input
                          name="last_name"
                          placeholder="Last Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.last_name || ""}
                          invalid={
                            validation.touched.last_name &&
                            validation.errors.last_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.last_name &&
                        validation.errors.last_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.last_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-6">
                      <Label className="form-label">
                        E-Mail<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="email"
                        placeholder="Enter Valid Email"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>

                      <div className="mb-3 col-6">
                      <Label className="form-label">
                        Phone<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="phone"
                        placeholder="Enter Valid Phone Number"
                        type="phone"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phone || ""}
                        invalid={
                          validation.touched.phone && validation.errors.phone
                            ? true
                            : false
                        }
                      />
                      {validation.touched.phone && validation.errors.phone ? (
                        <FormFeedback type="invalid">
                          {validation.errors.phone}
                        </FormFeedback>
                      ) : null}
                    </div>  
                    <div className="mb-3 col-6">
                      <Label className="form-label">
                        Password<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="password"
                        placeholder="new Password"
                        type="password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        invalid={
                          validation.touched.password && validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password && validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                    </div> 
</div>
                    
                  
                 
                    <Label>Image</Label>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        handleAcceptedFiles_2(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted uil uil-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles_2.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div
                              className="p-2"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                              <div
                                className="align-self-center"
                                onClick={() => {
                                  setselectedFiles_2([])
                                  setRemoveImage(true)
                                }}
                              >
                                <i
                                  className="uil uil-trash-alt font-size-24 text-danger"
                                  id="deletetooltip"
                                />
                                <UncontrolledTooltip
                                  placement="top"
                                  target="deletetooltip"
                                >
                                  Delete
                                </UncontrolledTooltip>
                              </div>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="">
                        Submit
                      </Button>{" "}
                      <Button type="reset" color="secondary" className="">
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default AddClient;
